import SRS from "../../../services/StudentRecordService"
import { getScreeningWindowsForSchoolYear } from "../../../services/screeningWindowService";

export async function hasPendingAssessment(studentId) {
    const {startDate, endDate} = getCurrentWindow();
    const limit = 1; // we only care if the last activity or its children are pending
    const type = ['assessment']
    // including "scored" in the status filter is
    // required to fetch status: "in_progress" activities
    const status = ["underReview", "in_progress", "scoring", "reassess", "scored", "assigned", "not_started"];
    const equated = false;
    const [assessment] = await SRS.studentActivities(studentId, limit, type, status, equated, startDate, endDate);
    return isPendingAssessment(assessment);
}

export function isPendingAssessment(activity) {
    if (!activity) return false;
    const {status, displayStatus} = activity;
    if (status === 'assigned' && displayStatus === 'started') return true;
    if (activity?.children?.some(x => x.status === 'underReview')) return true;
    // If none of the children are under review and the status is prereader, then nothing is pending (regardless of the check for statuses below)
    if(displayStatus === 'prereader') return false
    if (pendingStatus.includes(status)) return true;
    return false;
}

function getCurrentWindow() {
    const windows = getScreeningWindowsForSchoolYear();
    return windows.find(w => w.isCurrent);
}

export const pendingStatus = [
    'underReview',
    'in_progress',
    'scoring',
    'reassess'
];